import selectLocalExercise from './selectLocalExercise';
const selectSuccessMessage = (state, id) => {
  const localExercise = selectLocalExercise(state, id);
  if (localExercise === undefined) {
    return '';
  }
  return localExercise.successMessage;
};
export default selectSuccessMessage;